module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap6"
    }
  }, [_vm._v("Gold")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE DAY WHEN MERIDIAN")]), _vm._v(" was seven she found a large chunk of heavy metal. It was so thickly encrusted with dirt that even when she had washed it the metal did not shine through. Yet she knew metal was there, because it was so heavy. Finally, when she had dried off the water, she took a large file and filed away some of the rust. To her amazement what she had found was a bar of yellow gold. Bullion they called it in the movies. She filed a spot an inch square and ran with it (heavy as it was) to her mother, who was sitting on the back porch shelling peas.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’ve found some gold!” she shouted. “Gold!” And she placed the large heavy gold bar in her mother’s lap.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Move that thing,” her mother said sharply. “Don’t you see I’m trying to get these peas ready for supper?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But it’s gold!” she insisted. “Feel how heavy it is. Look how yellow it is. It’s gold, and it could make us rich!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But her mother was not impressed. Neither was her father or her brothers. She took her bar of gold and filed all the rust off it until it shone like a huge tooth. She put it in a shoe box and buried it under the magnolia tree that grew in the yard. About once a week she dug it up to look at it. Then she dug it up less and less ... until finally she forgot to dig it up. Her mind turned to other things.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5909f573","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/12-chap6.vue
// module id = 99
// module chunks = 0